module.exports = __webpack_public_path__ + "static/media/BankManagementSystem.e6d951fb.jpg";